import React from 'react';
import { ContentCarouselCardStoryblok } from '../../../../types/storyblok';
import { SplideSlide } from '@splidejs/react-splide';
import { ContentCarouselCardMobile } from './ContentCarouselCardMobile';
import { ContentCarouselCardDesktop } from './ContentCarouselCardDesktop';

export const ContentCarouselCard = (props: ContentCarouselCardStoryblok) => {
  if (!props.heading && !props.description && !props.link && !props.image) {
    return null;
  }

  return (
    <SplideSlide className="max-w-standard">
      <ContentCarouselCardMobile {...props} />
      <ContentCarouselCardDesktop {...props} />
    </SplideSlide>
  );
};

export default ContentCarouselCard;
